import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "hash",
  routes: [
    {
      path: '/introduce_pc',
      name: 'introduce_pc',
      component: () => import ('@/pages/introduce_pc/index'),
      redirect: '/pcHomepage',
      children: [{
        path: '/pcHomepage',
        name: 'pcHomepage',
        component: () => import ('@/pages/introduce_pc/homePage'),
      },{
        path: '/pcProductCenter',
        name: 'pcProductCenter',
        component: () => import ('@/pages/introduce_pc/productCenter'),
      },{
        path: '/pcNews',
        name: 'pcNews',
        component: () => import ('@/pages/introduce_pc/news'),
      },{
        path: '/pcInformation',
        name: 'pcInformation',
        component: () => import ('@/pages/introduce_pc/information'),
      },{
        path: '/pcRecruit',
        name: 'pcRecruit',
        component: () => import ('@/pages/introduce_pc/recruit'),
      },{
        path: '/pcContact',
        name: 'pcContact',
        component: () => import ('@/pages/introduce_pc/contact'),
      }]
    },
    {
      path: '/introduce_wap',
      name: 'introduce_wap',
      component: () => import ('@/pages/introduce_wap/index'),
      redirect: '/wapHome',
      children: [{
        path: '/wapHome',
        name: 'wapHome',
        component: () => import ('@/pages/introduce_wap/home'),
      },{
        path: '/wapProduct',
        name: 'wapProduct',
        component: () => import ('@/pages/introduce_wap/product'),
      },{
        path: '/wapNews',
        name: 'wapNews',
        component: () => import ('@/pages/introduce_wap/news'),
      },{
        path: '/wapInformation',
        name: 'wapInformation',
        component: () => import ('@/pages/introduce_wap/information'),
      },{
        path: '/wapRecruit',
        name: 'wapRecruit',
        component: () => import ('@/pages/introduce_wap/recruit'),
      },{
        path: '/wapContact',
        name: 'wapContact',
        component: () => import ('@/pages/introduce_wap/contact'),
      }]
    },
    {
      path: '/wapHomeDetails',
      name: 'wapHomeDetails',
      component: () => import ('@/pages/introduce_wap/homeDetails'),
    },
    {
      path: '/wapNewsDetails',
      name: 'wapNewsDetails',
      component: () => import ('@/pages/introduce_wap/newsDetails'),
    },
    {
      path: '/wapPositionList',
      name: 'wapPositionList',
      component: () => import ('@/pages/introduce_wap/positionList'),
    },
    {
      path: '/wapPositionDetails',
      name: 'wapPositionDetails',
      component: () => import ('@/pages/introduce_wap/positionDetails'),
    },
    {
      path: '/wapOtherParts',
      name: 'wapOtherParts',
      component: () => import ('@/pages/introduce_wap/otherParts'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js